import $ajax from 'axios'
// import {Message} from 'element-ui'
import {hideLoad} from '@/tools/loading.js' // 引入封装的loading方法
import {getRoot} from '@/utils/updateCheck.js'

// 登录成功接口 post
// id str
// type str 当前支持[weixinsns,localpass]
// secret str 密码
function reqLogin (id, secret, fn) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('type', 'localpass')
  formData.append('secret', secret)
  $ajax.post('/v2/auth/Login', formData).then(res => {
    hideLoad()
    fn && fn(res.data)
  }).catch(err => {
    hideLoad()
  })
}

function reqLogin2 (loginForm, fn) {
  let formData = new FormData()
  formData.append('authType', loginForm.authType)
  formData.append('authIDType', loginForm.authIDType)
  formData.append('authID', loginForm.authID)
  formData.append('authSecret', loginForm.authSecret)
  $ajax.post('v2/auth2/Login', formData).then(res => {
    hideLoad()
    fn && fn(res.data)
  }).catch(err => {
    hideLoad()
  })
}

// 获取用户信息 get
// token str
async function getUserInfo (token, fn) {
  await getRoot()
  $ajax.get('v2/auth2/GetTokenInfo', {}, {
    headers: {
      token: token
    }
  }).then(res => {
    hideLoad()
    fn && fn(res.data)
  }).catch(err => {
    hideLoad()
  })
}

export {reqLogin, reqLogin2, getUserInfo}



// WEBPACK FOOTER //
// ./src/apis/login.js